export const FilterTypesEnum = {
  eq: "eq",
  lt: "lt",
  gt: "gt",
  in: "in",
  icontains: "icontains",
  not_icontains: "not_icontains",
  ne: "ne",
  in_at: "in_at",
  contains_any: "contains_any",
} as const;

export type FilterTypesEnum =
  (typeof FilterTypesEnum)[keyof typeof FilterTypesEnum];

export const ARRAY_FILTERS: FilterTypesEnum[] = [
  FilterTypesEnum.in,
  FilterTypesEnum.contains_any,
  FilterTypesEnum.in_at,
];

export interface ApiFilterInterface {
  name: string;
  operator: FilterTypesEnum;
  value: any;
  index?: number;
}

export interface AdsFilterInterface extends ApiFilterInterface {
  index: number;
  label: string;
  inputLabel?: string;
  type?: string;
}

export type FilterLogic = "and" | "or";

export interface KpiFilterGroup {
  id: string;
  conditions: AdsFilterInterface[];
}

export interface KpiFilterExpressionGroup extends KpiFilterGroup {
  logic: FilterLogic;
}

export interface KpiFilterExpression {
  logic: FilterLogic;
  groups: KpiFilterExpressionGroup[];
}

export interface ApiKpiFilterClause {
  logic: FilterLogic;
  conditions: ApiFilterInterface[];
}

export interface ApiKpiFilterExpression {
  logic: FilterLogic;
  clauses: ApiKpiFilterClause[];
}

export type FilterTypes = {
  label: string;
  value: string;
  type: string;
  availableFilter?: FilterTypesEnum[];
  hidden?: boolean;
  inputLabel?: string;
  options?: Array<{ label: string; value: any }>;
};
